import { UseFormReturnType } from '@mantine/form';

import { Customer } from '@e-origin/shared';

import { REPRESENTATIVE_STATUS_FIXED } from '@constants';

interface HandleStatusChangeParams {
  status: string;
  form: UseFormReturnType<any>;
  customerDetails: Customer;
  buildFormValues: (customer: Customer) => any;
}

const representativeDataCache = new Map<number, Customer['representative']>();

const clearRepresentativeData = (statusValue: number) => ({
  identificationNumberIDMS: null,
  name: '',
  address: {
    street: '',
    postcode: '',
    city: '',
    country: '',
  },
  status: statusValue,
});

export const handleRepresentativeStatusChange = ({ status, form, customerDetails, buildFormValues }: HandleStatusChangeParams) => {
  const newStatus = Number(status);
  const currentStatus = form.values.representative.status;

  representativeDataCache.set(currentStatus, form.values.representative);

  const cachedData = representativeDataCache.get(newStatus);

  if (newStatus === REPRESENTATIVE_STATUS_FIXED) {
    form.setFieldValue('representative', clearRepresentativeData(newStatus));
  } else if (cachedData) {
    form.setFieldValue('representative', cachedData);
  } else {
    const originalFormValues = buildFormValues(customerDetails);
    form.setFieldValue('representative', {
      ...originalFormValues.representative,
      status: newStatus,
    });
  }
};
